export function useCreditsResponseEvent(params) {
    return new CustomEvent("growtypeChatUseCreditsResponse", {
        detail: params
    });
}
